import React from "react";

export const CancelTravelExemptionModalContent = (props) => {
  
    const advance = () => {
      props.cardInfo.isCancellation = true;
      window.scrollTo(0, 0);
      props.callCancelExistingTravel(props.existingTravel.CardDetails.Id, props.existingTravel.ExemptionNumber);
      props.closeModal();
      props.advanceToCompleteStep();
  };

  return (
    <div>
      <div className="bold" style={{fontSize: "18px" }}>Are you sure you want to cancel this travel exemption?</div>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance();
        }}
        data-e2e-id="proceed-cancel-travel-exemption"
      >
        Yes
      </button>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          props.closeModal();
        }}
        data-e2e-id="cancel-cancel-travel-exemption"
      >
        No
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/modal/cancel-travel-exemption-modal.js